import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
  selector: 'icc-table-text',
  templateUrl: './icc-table-text.component.html',
  styleUrls: ['./icc-table-text.component.less'],
})
export class IccTableTextComponent implements OnInit {
  constructor() {}
  @Input() width: number;
  @Input() text: any;
  @Input() url: any;
  @Input() isBold: boolean = false;
  @Input() color: string;
  @Input() textAlign: string = 'center';
  @Input() tooltipMaxWidth: string = '';

  @Output() textclick: EventEmitter<any> = new EventEmitter<any>();
  ngOnInit(): void {}

  textClick() {
    this.textclick.emit(this.text);
  }

  // 处理URL的https前缀
  formatHttps(url) {
    const httpsReg = /^https:\/\//i;
    const httpReg = /^http:\/\//i;
    if (httpsReg.test(url)) {
      return url;
    } else if (httpReg.test(url)) {
      return url;
    } else {
      return 'https://' + url.replace(/^https:\/\//i, '');
    }
  }
}
